import { Box, Typography, useTheme } from '@ublend-npm/aulaui-core';
import React, { useMemo } from 'react';
import { createStyles } from './ConversionDetails.styles';

type ConversionDetailsProps = {
  currentTitle: string;
  convertedExtensionTitle?: string | null;
  parentAssignmentTitle?: string | null;
};

const ConversionDetails = ({
  currentTitle,
  convertedExtensionTitle = null,
  parentAssignmentTitle = null,
}: ConversionDetailsProps) => {
  // Get the styles
  const styles = createStyles(useTheme());

  const metaData = useMemo(
    () => ({
      existingAssignment: {
        title: 'Existing assignment:',
        value: `"${currentTitle}"`,
      },
      convertedExtension: {
        title: 'Will be turned into an extension called:',
        value: `"${convertedExtensionTitle}"`,
      },
      parentAssignment: {
        title: 'As a part of the assignment:',
        value: parentAssignmentTitle
          ? `"${parentAssignmentTitle}"`
          : 'Select a destination assignment above',
      },
    }),
    [currentTitle, convertedExtensionTitle, parentAssignmentTitle]
  );

  return (
    <Box>
      {Object.values(metaData)?.map((item) => (
        <Box key={item?.title} sx={styles.metaDataContainer}>
          <Typography sx={styles.main}>{item?.title}</Typography>
          <Typography sx={{ ...styles.main, ...styles.subtitle }}>
            {item?.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default React.memo(ConversionDetails);
